import { render, staticRenderFns } from "./Reserve.vue?vue&type=template&id=3bfd448e&scoped=true"
import script from "./Reserve.vue?vue&type=script&lang=js"
export * from "./Reserve.vue?vue&type=script&lang=js"
import style0 from "./Reserve.vue?vue&type=style&index=0&id=3bfd448e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfd448e",
  null
  
)

export default component.exports